import React, { useState } from "react";
import "./advertisement.scss";
import NewsPaperComponent from "./newsPaperComponent";
import axios from "axios";
import ImageComponent from "../CustomComponent/ImageComponent";

export default function AdvertisementPreview({
  verticalValue,
  horizontalValue,
  image,
  handleFormToFile,
  categoryID,
  originalFile,
  date,
  number,
  paperType,
  sectorType,
  sector,
  paper,
}) {
  const [newspaperPrice, setNewspaperPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [priceAfterDiscount, setPriceAfterDiscount] = useState(0);
  const [publishID, setPublishID] = useState(0);
  const horizontal = horizontalValue;
  const vertical = verticalValue;
  const selectedDate = date;
  const [isSubmitting, setSubmitting] = useState(false);

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  const paperValue = paper.find(function (item) {
    return item.id == paperType;
  })?.paper_type;

  const sectorValue = sector.find(function (item) {
    return item.id == sectorType;
  })?.sector_type;

  let submitToApi = () => {
    if (number.length === 0) {
      return toastr.info("Please Enter Number");
    } else if (publishID == 0) {
      return toastr.info("Please Select Any Platform");
    } else if (selectedDate == "") {
      return toastr.info("Please Select Publish Date");
    }
    const formData = new FormData();
    formData.append("advertisement[publish_id]", publishID);
    formData.append("advertisement[vertical]", vertical);
    formData.append("advertisement[horizontal]", horizontal);
    formData.append("advertisement[image]", originalFile);
    formData.append("advertisement[categories_id]", categoryID);
    formData.append("advertisement[amount]", priceAfterDiscount);
    formData.append("advertisement[publish_date]", selectedDate);
    formData.append("number", number);

    axios
      .post("/ads", formData, config)
      .then((response) => {
        if (response.data.status === 22) {
          setSubmitting(false);
          toastr.error(response.data.msg);
          return;
        }
        toastr.success(response.data.msg);
        window.location.replace(
          window.location.origin + "/dashboard/my_designs"
        );
      })
      .catch((e) => {
        console.log(e);
        setSubmitting(false);
        toastr.error("Unable To Post");
      });
  };
  return (
    <>
      <div className="view-platform">
        <h2 className="title">Select Platform</h2>
        <div className="row ">
          <div className="col-lg-6 col-md-12">
            <div className="view-platform-section">
              <NewsPaperComponent
                newspaperPrice={newspaperPrice}
                setNewspaperPrice={setNewspaperPrice}
                discount={discount}
                setDiscount={setDiscount}
                priceAfterDiscount={priceAfterDiscount}
                setPriceAfterDiscount={setPriceAfterDiscount}
                setPublishID={setPublishID}
                categoryID={categoryID}
                horizontal={horizontal}
                vertical={vertical}
                paperType={paperType}
                sectorType={sectorType}
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            {/* <div className="view-advertisment-cover">
                <img src={require("../../images/bg-paper.png")} alt="img" />
              </div> */}
            <div className="ad-form-image block-card">
              <div className="row review-input-block">
                <p className="col-md-4">
                  <label>HORIZONTAL:</label>
                  <span className="review-value">{horizontal} col</span>
                </p>
                <p className="col-md-4">
                  <label>Vertical:</label>
                  <span className="review-value">{vertical} cm</span>
                </p>
                <p className="col-md-4">
                  {" "}
                  <label>AD Size:</label>{" "}
                  <span className="review-value">
                    {horizontal * vertical} cc
                  </span>
                </p>
                <p className="col-md-4">
                  {" "}
                  <label>Sector:</label>{" "}
                  <span className="review-value">{sectorValue}</span>
                </p>
                <p className="col-md-4">
                  {" "}
                  <label>Page:</label>{" "}
                  <span className="review-value">{paperValue}</span>
                </p>
                <p className="col-md-4">
                  {" "}
                  <label>Number:</label>{" "}
                  <span className="review-value">{number}</span>
                </p>
                <p className="col-md-6">
                  <label>Date:</label>{" "}
                  <span className="review-value">
                    {new Date(selectedDate).toISOString().slice(0, 10)}
                  </span>
                </p>
              </div>
              <ImageComponent image={image} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="btn-block-left">
            <button onClick={() => handleFormToFile()} className="action-btn">
              Back
            </button>
            <button
              disabled={isSubmitting}
              onClick={() => {
                submitToApi();
                setSubmitting(true);
              }}
              className="main-btn"
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
